import { useContext } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider.js';
const useCurrentUser = () => {
  const {
    updateUser,
    user,
    refreshUser
  } = useContext(AuthenticationContext);
  return {
    user,
    updateUser,
    refreshUser
  };
};
export { useCurrentUser as default, useCurrentUser };